import React from 'react'

const Contact = () => {
  return (
    <section className="py-16 px-4 md:px-6">
      <div className="container mx-auto">
        <div className="section-bg">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold section-title-enhanced mb-6">
              📞 Let's Make Your Event Unforgettable
            </h2>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed mb-8">
              Ready to transform your vision into reality? Contact AuraSquare Events today and let's start planning your perfect celebration!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-8">
            <div className="card p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-[#25D366] to-[#128C7E] rounded-full flex items-center justify-center">
                <i className="fab fa-whatsapp text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">WhatsApp</h3>
              <a href="https://wa.me/919444848616" className="text-[#1abc9c] font-semibold text-lg hover:underline whitespace-nowrap" target="_blank" rel="noopener noreferrer">
                +91 9444 848 616
              </a>
              <p className="text-gray-600 mt-2 text-sm">Quick responses guaranteed</p>
            </div>

            <div className="card p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-[#f5576c] to-[#f093fb] rounded-full flex items-center justify-center">
                <i className="fas fa-envelope text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Email</h3>
              <a href="mailto:aurasquare.events@gmail.com" className="text-[#1abc9c] font-semibold text-sm hover:underline block px-2">
                aurasquare.events@gmail.com
              </a>
              <p className="text-gray-600 mt-2 text-sm">Get detailed quotations</p>
            </div>

            <div className="card p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-[#667eea] to-[#764ba2] rounded-full flex items-center justify-center">
                <i className="fas fa-phone text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Call Us</h3>
              <a href="tel:+919444848616" className="text-[#1abc9c] font-semibold text-lg hover:underline whitespace-nowrap">
                +91 9444 848 616
              </a>
              <p className="text-gray-600 mt-2 text-sm">Mon-Sun: 9 AM - 9 PM</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="card p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045] rounded-full flex items-center justify-center">
                <i className="fab fa-instagram text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Instagram</h3>
              <a href="https://www.instagram.com/aurasquare.events" className="text-[#1abc9c] font-semibold text-base hover:underline" target="_blank" rel="noopener noreferrer">
                @aurasquare.events
              </a>
              <p className="text-gray-600 mt-2 text-sm">Follow for updates</p>
            </div>

            <div className="card p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-[#1abc9c] to-[#16a085] rounded-full flex items-center justify-center">
                <i className="fas fa-map-marker-alt text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Address</h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                24, Mettu Street, Kundrathur,<br/>
                Chennai, Tamil Nadu 600069
              </p>
              <p className="text-gray-600 mt-2 text-sm">By appointment</p>
            </div>

            <div className="card p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-[#4285F4] to-[#34A853] rounded-full flex items-center justify-center">
                <i className="fas fa-map text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Google Maps</h3>
              <a href="https://maps.app.goo.gl/LXQLXeChH4M59WY88" className="text-[#1abc9c] font-semibold text-base hover:underline" target="_blank" rel="noopener noreferrer">
                Get Directions
              </a>
              <p className="text-gray-600 mt-2 text-sm">Find us easily</p>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="https://wa.me/919444848616?text=Hi%20AuraSquare!%20I'm%20interested%20in%20your%20event%20management%20services."
              className="premium-btn text-xl px-12 py-6 inline-flex items-center gap-3"
              style={{ background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp text-2xl"></i>
              <span>Start Planning Your Event Now</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
